<template>
  <custom-dialog
    class="add-pay-info-public-step1-dialog"
    :title="model.title"
    width="750px"
    :visible="visible"
    v-on="$listeners"
    :appendToBody="true"
  >
    <div class="dialog-body">
      <div class="content">
        <div class="base-info">
          <div class="title">{{ $t('fms_add_pay_info_public_step1_dialog.zhuan_zhang_xin_xi') }}</div>
          <el-form
            label-position="top"
            :model="form"
            :rules="rules"
            ref="form"
          >
            <el-form-item :label="isReverse ? $t('fms_add_pay_info_public_step1_dialog.fu_kuan_fang') : $t('fms_add_pay_info_public_step1_dialog.shou_kuan_fang')">
              <el-input
                v-model="form.sellerName"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="isReverse ? $t('fms_add_pay_info_public_step1_dialog.fkfzh') : $t('fms_add_pay_info_public_step1_dialog.skfzh')"
              prop="sellerAccount"
              class="row"
            >
              <custom-select
                v-if="dicMap.bank_branch"
                v-model="form.sellerAccount"
                url="PartnerBankcardListByOrgId"
                :params="{orgId:receivableOrgId}"
                :props="{label:'label', value: 'depositNumber'}"
                @getList="onSellerAccountGetList"
                :dataFilter="bankListFilter"
                ref="sellerBank"
                :key="sellerBankKey"
                disabled
              ></custom-select>
              <div
                class="item"
                @click="showReceivableAccountManage"
              >{{ $t('fms_add_pay_info_public_step1_dialog.xuan_ze') }}</div>
            </el-form-item>
            <el-form-item :label="isReverse ? $t('fms_add_pay_info_public_step1_dialog.shou_kuan_fang') : $t('fms_add_pay_info_public_step1_dialog.fu_kuan_fang')">
              <el-input
                v-model="form.buyerName"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="isReverse ? $t('fms_add_pay_info_public_step1_dialog.skfzh') : $t('fms_add_pay_info_public_step1_dialog.fkfzh')"
              prop="buyerAccount"
              class="row"
            >
              <custom-select
                v-if="dicMap.bank_branch"
                v-model="form.buyerAccount"
                url="PartnerBankcardListByOrgId"
                :params="{orgId:payableOrgId}"
                :props="{label:'label', value: 'depositNumber'}"
                @getList="onBuyerAccountGetList"
                :dataFilter="bankListFilter"
                ref="buyBank"
                :key="buyBankKey"
                disabled
              ></custom-select>
              <div
                class="item"
                @click="showPayableAccountManage"
              >{{ $t('fms_add_pay_info_public_step1_dialog.xuan_ze') }}</div>
            </el-form-item>
            <el-form-item :label="$t('fms_add_pay_info_public_step1_dialog.fu_kuan_jin_e')">
              <el-input
                v-model="form.totalAmount"
                type="number"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="preview-info">
          <div class="preview-content">
            <div class="line"></div>
            <div class="info">
              <div class="title">{{ $t('fms_add_pay_info_public_step1_dialog.xin_xi_yu_lan') }}</div>
              <div class="details">
                <div class="item">
                  <div class="key">{{ $t('fms_add_pay_info_public_step1_dialog.zhang_hu_ming_cheng') }}:</div>
                  <div class="val">{{copyInfo.accountName}}</div>
                </div>
                <div class="item">
                  <div class="key">{{ $t('fms_add_pay_info_public_step1_dialog.yin_hang_zhang_hao') }}:</div>
                  <div class="val">{{copyInfo.account}}</div>
                </div>
                <div class="item">
                  <div class="key">{{ $t('fms_add_pay_info_public_step1_dialog.kai_hu_yin_hang') }}:</div>
                  <div class="val">{{copyInfo.bank}}</div>
                </div>
                <div class="item">
                  <div class="key">{{ $t('fms_add_pay_info_public_step1_dialog.zhuan_zhang_bei_zhu') }}:</div>
                  <div class="val">{{copyInfo.tradeCode}} <span class="red">(*{{ $t('fms_add_pay_info_public_step1_dialog.dksqbz') }})</span></div>
                </div>
              </div>
              <div class="amount">
                <div class="key">{{ $t('fms_add_pay_info_public_step1_dialog.zhuan_zhang_jin_e') }}:</div>
                <div class="val">￥{{form.totalAmount || 0}}</div>
              </div>
              <!-- 若是登记收款：在复制按钮上方加入 ‘请将复制的信息发给付款方账务人员付款’  -->
              <div
                v-if="!paymentOrReceivable"
                class="receive-tips"
              >{{ $t('fms_add_pay_info_public_step1_dialog.qjfzdxxfjfkfzwryfk') }}</div>
              <el-button
                type="warning"
                class="copy"
                @click="onCopy"
              >
                <i class="icon icon-copy1"></i>
                <span>{{ $t('fms_add_pay_info_public_step1_dialog.fu_zhi') }}</span>
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <add-bank-card-dialog
      v-if="dialog1Visible"
      @close="dialog1Visible = false"
      :model="dialog1Model"
      @success="updateBankData"
    ></add-bank-card-dialog>
    <add-bank-card-dialog
      v-if="dialog2Visible"
      @close="dialog2Visible = false"
      :model="dialog2Model"
      @success="updatePayAccountBankData"
    ></add-bank-card-dialog>
    <bank-account-manage-dialog
      v-if="payableAccountVisible"
      @close="payableAccountVisible=false"
      :model="payableAccountModel"
      :orgId="payableAccountModel.orgId"
      :isPayableAccountType="payableAccountModel.isPayableAccountType"
      :isPayableOrgan="payableAccountModel.isPayableOrg"
      @confirm="onPayableAccountConfirm"
      @edit="onEditBuyerAccount"
      @add="onAddBuyerAccount"
      :accountManage="accountManage"
    ></bank-account-manage-dialog>
    <bank-account-manage-dialog
      v-if="receivableAccountVisible"
      @close="receivableAccountVisible=false"
      :model="receivableAccountModel"
      :orgId="receivableAccountModel.orgId"
      :isPayableAccountType="receivableAccountModel.isPayableAccountType"
      :isPayableOrgan="receivableAccountModel.isPayableOrg"
      @confirm="onReceivableAccountConfirm"
      @edit="onEditSellerAccount"
      @add="onAddSellerAccount"
      :accountManage="accountManage"
    ></bank-account-manage-dialog>
  </custom-dialog>
</template>

<script>
// 新增账单
import dialogMixins from '@/mixins/dialog_mixins';
import addBankCardDialog from '@/pages/crm/components/bankCardDialog';
import bankAccountManageDialog from '@/pages/fms/components/bank_account_manage_dialog';

export default {
  name: 'addPayInfoPublicStep1Dialog',
  mixins: [dialogMixins],
  props: {
    totalAmount: [Number, String],
    paymentCode: [Number, String],
    // false-收款  true-付款
    paymentOrReceivable: {
      type: Boolean,
      default: false
    },
    // 是否反转应付，应收账号显示
    isReverse: {
      type: Boolean,
      default: false
    },
    // 权限-账户管理, 默认有
    accountManage: {
      type: Boolean,
      default: true
    }
  },
  components: {
    addBankCardDialog,
    bankAccountManageDialog
  },
  computed: {
    rules() {
      return {
        sellerAccount: [
          { required: true, message: this.$t('Common.com_required') },
          { max: 30, message: this.$t('Common.com_rules_length_max', [30]) }
        ],
        buyerAccount: [
          { required: true, message: this.$t('Common.com_required') },
          { max: 30, message: this.$t('Common.com_rules_length_max', [30]) }
        ],
        // tradeFinishTime: { required: true, message: '必填项' }
      };
    },
    receivableOrgId() {
      const outerItem = this.model.data && this.model.data.outerItem ? this.model.data.outerItem : {};
      return outerItem.receivableOrgId;
    },
    payableOrgId() {
      const outerItem = this.model.data && this.model.data.outerItem ? this.model.data.outerItem : {};
      return outerItem.payableOrgId;
    },
    buyerName() {
      const outerItem = this.model.data && this.model.data.outerItem ? this.model.data.outerItem : {};
      return outerItem.payableOrgName;
    },
    sellerName() {
      const outerItem = this.model.data && this.model.data.outerItem ? this.model.data.outerItem : {};
      return outerItem.receivableOrgName;
    },
    copyInfo() {
      /**
       * 账户名称
       * 银行账户
       * 开户行
       * 转账备注
       * 付款金额
       */
      const ret = {};
      const {
        buyerAccount,
        sellerAccount,
        // 转账金额
        totalAmount, } = this.form;


      // 账户名称
      ret.accountName = this.isReverse ? this.form.buyerName : this.form.sellerName;

      // 付款人
      ret.buyerAccount = this.isReverse ? sellerAccount : buyerAccount;
      // 收款人
      ret.sellerAccount = this.isReverse ? buyerAccount : sellerAccount;

      // 付款金额
      ret.totalAmount = totalAmount;


      // 转账备注
      ret.tradeCode = this.paymentCode.slice(-6);

      const accountList = this.isReverse ? this.buyerAccountList : this.sellerAccountList;

      const sellerItem = accountList.find(item => item.depositNumber === ret.sellerAccount);
      if (sellerItem) {
        // 开户行
        const bank = this.dicMap.bank_branch[sellerItem.bankCode] || sellerItem.bankName;

        const {
          // 支行
          depositBank,
          // 银行账号
          depositNumber,

        } = sellerItem;


        // 银行账户
        ret.account = depositNumber;
        // 开户行
        ret.bank = `${bank}${depositBank}`;

      }
      return ret;
    }
  },
  data() {
    return {
      payableAccountVisible: false,
      payableAccountModel: {},

      receivableAccountVisible: false,
      receivableAccountModel: {},
      form: {
        // 付款方账号
        buyerAccount: '',
        // 付款方
        buyerName: '',
        // 收款方
        sellerName: '',
        // 收款方账号
        sellerAccount: '',
        // 交易日期
        totalAmount: '',
        // 交易日期
        tradeFinishTime: '',
        // 摘要
        tradeCode: '',
        tradeId: '',
        buyerId: '',
        sellerId: '',
      },
      transactionReceipt: [],
      sellerAccountList: [],
      buyerAccountList: [],
      selectDate: '',
      initValue: '',
      addBankModel: {},
      addBankVisible: false,

      dialog1Visible: false,
      dialog1Model: {},
      dialog2Visible: false,
      dialog2Model: {},
      buyBankKey: 1,
      sellerBankKey: 1,
      outerItem: {},
    };
  },
  methods: {
    onAddBuyerAccount() {
      this.buyBankKey++;
      this.$emit('add:buyer');
    },
    onAddSellerAccount() {
      this.sellerBankKey++;
      this.$emit('add:seller');
    },
    onEditBuyerAccount(form) {
      const { buyerAccount } = this.form;
      const buyerAccountList = this.buyerAccountList;
      const item = buyerAccountList.find(obj => obj.depositNumber === buyerAccount);
      if (item) {
        // 如果已有的账号号码被修改，则要同步最新的账号信息
        if (item.bankcardId === form.bankcardId) {
          this.form.buyerAccount = form.depositNumber;

          // 让select组件重新加载数据渲染
          this.buyBankKey++;

          // 通知外部列表更新
          this.$emit('edit:buyer', form);
        }
      }
    },
    onEditSellerAccount(form) {
      const { sellerAccount } = this.form;
      const sellerAccountList = this.sellerAccountList;
      const item = sellerAccountList.find(obj => obj.depositNumber === sellerAccount);
      if (item) {
        // 如果已有的账号号码被修改，则要同步最新的账号信息
        if (item.bankcardId === form.bankcardId) {
          this.form.sellerAccount = form.depositNumber;

          // 让select组件重新加载数据渲染
          this.sellerBankKey++;

          // 通知外部列表更新
          this.$emit('edit:seller', form);
        }
      }
    },
    onPayableAccountConfirm(row) {
      this.form.buyerAccount = row.depositNumber;
    },
    showPayableAccountManage() {
      this.payableAccountModel = {
        title: this.form.buyerName,
        orgId: this.payableOrgId,
        isPayableAccountType: true,
        isPayableOrg: this.isPayableOrg(this.payableOrgId),
        // 条件判断：付款方不是 HQ
        isPaymentConditionMet: this.outerItem.payableOrgType !== 'HQ',
      };
      this.payableAccountVisible = true;
    },
    onReceivableAccountConfirm(row) {
      this.form.sellerAccount = row.depositNumber;
    },
    showReceivableAccountManage() {
      this.receivableAccountModel = {
        title: this.form.sellerName,
        orgId: this.receivableOrgId,
        isPayableAccountType: false,
        isPayableOrg: this.isPayableOrg(this.payableOrgId),
        // 自己的都可以修改
        isPaymentConditionMet: true
      };
      this.receivableAccountVisible = true;
    },
    onBuyerAccountGetList(list) {
      this.buyerAccountList = list;
      if (this.form.buyerAccount) {
        return;
      }
      const item = list.find(obj => obj.isDefault);
      if (item) {
        this.form.buyerAccount = item.depositNumber;
      }
    },
    onCopy() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const copyInfo = this.copyInfo;
          const ret = [
            // 账户名称
            this.$t('fms_add_pay_info_public_step1_dialog.zhang_hu_ming_chengo', [copyInfo.accountName]),
            // 银行账户
            this.$t('fms_add_pay_info_public_step1_dialog.yin_hang_zhang_huo', [copyInfo.account]),
            // 开户行
            this.$t('fms_add_pay_info_public_step1_dialog.kai_hu_hango', [copyInfo.bank]),
            // 转账备注
            this.$t('fms_add_pay_info_public_step1_dialog.zhuan_zhang_bei_zhuo', [copyInfo.tradeCode]),
            // 付款金额
            this.$t('fms_add_pay_info_public_step1_dialog.fu_kuan_jin_eo', [copyInfo.totalAmount]),
          ];
          this.$copyToClip(ret.join('\r\n'), this.$t('Common.com_copy_success'));
          const emitData = this.getEmitData();

          this.$emit('confirm', emitData);
          this.visible = false;
        }
      });
    },
    getEmitData() {
      // 收款方（卖方）
      const sellerItem = this.sellerAccountList.find(item => item.depositNumber === this.form.sellerAccount);
      const { buyerName, sellerName, sellerAccount, totalAmount } = this.form;
      const ret = {
        ...this.form,
        buyerName,
        sellerName,
        sellerAccount,
        totalAmount,
        attachs: [],
        tradeMethod: this.dicMap.payment_class.public_account,
      };
      if (sellerItem) {
        ret.sellerBank = sellerItem.depositBank;
      }
      ret.buyerId = this.payableOrgId;
      ret.sellerId = this.receivableOrgId;
      ret.buyerTradeRemark = this.paymentCode.slice(-6);
      return ret;
    },
    init() {
      const outerItem = this.model.data && this.model.data.outerItem ? this.model.data.outerItem : {};
      const form = this.model.data.form;
      this.$setFormatData(this.form, form);
      this.form.buyerName = this.buyerName;
      this.form.sellerName = this.sellerName;
      this.form.tradeCode = this.paymentCode;
      if (this.totalAmount) {
        this.form.totalAmount = this.totalAmount;
      }
      this.form.buyerId = outerItem.payableOrgId;
      this.form.sellerId = outerItem.receivableOrgId;
      this.outerItem = outerItem;
    },
    onSellerAccountGetList(list) {
      this.sellerAccountList = list;
      if (this.form.sellerAccount) {
        return;
      }
      const item = list.find(obj => obj.isDefault);
      if (item) {
        this.form.sellerAccount = item.depositNumber;
      }
    },
    // 格式化银行列表数据，使label为：账号/支行
    bankListFilter(list) {
      list.forEach((item) => {
        const depositBank = item.depositBank;
        const depositNumber = item.depositNumber;
        item.label = [
          depositNumber,
          depositBank
        ].join('/');
      });
      return list;
    },
    // 更新银行列表
    updateBankData() {
      this.$refs.sellerBank.getSelectList();
      this.$emit('update:sellerBank');
    },
    // 更新银行列表 - 付款方账号
    updatePayAccountBankData() {
      this.$refs.buyBank.getSelectList();
      this.$emit('update:buyerBank');
    },
  },
  mounted() {
    this.getDicMap('payment_class');
    this.getDicMap('bank_branch', () => {
      this.init();
    }, { propKey: 'code', propVal: 'name' });
  },
};
</script>

<style lang="scss">
.add-pay-info-public-step1-dialog {
  .el-dialog .el-dialog__body .el-form-item {
    margin-bottom: 16px;
  }
  .el-form--label-top .el-form-item__label {
    padding-bottom: 0;
  }

  .row {
    position: relative;
    .el-form-item__content {
      position: static;
    }
    .item {
      line-height: 17px;
      height: 17px;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 100;
      cursor: pointer;
      color: #00a0d9;
      .label {
        float: left;
        padding-left: 5px;
        font-size: 12px;
        text-decoration: underline;
      }
    }
  }

  .copy {
    width: 100%;
    margin-top: 24px;
  }
  .content {
    overflow: hidden;
    .base-info {
      float: left;
      width: 317px;
      padding-bottom: 50px;

      .title {
        color: #202945;
        line-height: 17px;
        font-size: 12px;
        font-weight: bold;
        margin-bottom: 16px;
      }
    }

    .preview-info {
      overflow: hidden;
      padding-left: 48px;
      padding-top: 27px;
      margin-bottom: 48px;

      .preview-content {
        width: 313px;
        border-radius: 4px;
        overflow: hidden;
        border: 1px solid #f5f5f5;

        .line {
          width: 100%;
          height: 3px;
          background: #00a0d9;
        }
        .info {
          padding: 24px 24px 32px 24px;
          .title {
            color: #202945;
            line-height: 20px;
            font-size: 14px;
            font-weight: bold;
          }

          .details {
            margin-top: 24px;
            .red {
              color: #eb5a5a;
            }
            .item {
              &:nth-child(n + 2) {
                margin-top: 8px;
              }
              overflow: hidden;
              line-height: 21px;
              .key {
                float: left;
                font-size: 14px;
                color: #4d4d4d;
              }
              .val {
                padding-left: 16px;
                font-size: 14px;
                color: #1a1a1a;
                overflow: hidden;
                word-break: break-all;
                white-space: normal;
              }
            }
          }

          .amount {
            line-height: 27px;
            overflow: hidden;
            margin-top: 24px;
            .key {
              float: left;
              color: #4d4d4d;
              font-size: 14px;
            }
            .val {
              overflow: hidden;
              padding-left: 16px;
              color: #00a0d9;
              font-size: 18px;
              font-weight: bold;
            }
          }
        }
      }
    }
  }

  .receive-tips {
    margin-top: 15px;
    font-size: 12px;
    font-weight: bold;
    color: #ff5c5b;
  }
}
</style>
copy
